<template>
  <div class="container">
    <div class="background">
      <div class="block">
        <div class="title">{{getDict(17)}}</div>
        <div class="right-box">
          <div class="select-box">
            <div 
              class="item" 
              v-for="(item,index) in caseList"
              :style="{width:100/lineItemNum + '%',marginTop:index < lineItemNum?0:undefined}"
              @click="handleSelectClick(item.id)"
            >
              <i 
                class="icon " 
                :class="{'icon-select':selected.includes(item.id)}"
                
              ></i>
              <span 
                class="desc"                 
              >{{item.name}}</span>
              
            </div>
          </div>
          
        </div>
      </div>

      <div class="block input">
        <div class="title">{{getDict(18)}}</div>
        <div class="right-box">
          <div class="input-box">
            <textarea class="" v-model="issue" type="" name=""></textarea>
            <!-- <input class="" v-model="issue" type="" name=""> -->
          </div>
          
        </div>
      </div>
      <div class="block input">
        <div class="title">{{getDict(19)}}</div>
        <div class="right-box">
          <div class="input-box">
            <input class="" v-model="email" type="" name="">
          </div>
          
        </div>
      </div>
      <div class="block tips">※ {{getDict(27)}}</div>
      <div class="block button">
        <button type="button" @click="submit">{{getDict(20)}}</button>
      </div>
      
    </div>
    <alert ref="alertBox"></alert>
  </div>
</template>

<script>
  import { getDict, axios, getPageLevelMixin } from '../../common'
  import { mapState, mapGetters } from 'vuex'
  import alert from '../../components/alert'

  export default {
    name: 'feedback',
    mixins:[getPageLevelMixin],
    props:{
      isRouteOpen:{
        default:false,
      },
    },
    data(){
      return {
        pageLevel:2,
        /*caseList:[
          {
            name:'无法播放1',
            id:1,
          },{
            name:'无法播放2',
            id:2,
          },{
            name:'无法播放3',
            id:3,
          },{
            name:'无法播放4',
            id:4,
          },{
            name:'无法播放5',
            id:5,
          },{
            name:'无法播放6',
            id:6,
          },{
            name:'无法播放7',
            id:7,
          }
        ],*/
        selected:[],
        email:'',
        issue:'',
      }
    },
    computed:{
      ...mapState(['_feedbackObj','lang']),
      caseList(){
        return this._feedbackObj.feedbackTagList;
      },
      lineItemNum(){
        return this.lang == 'zht'?3:2;
      },
      
    },
    watch:{
      caseList(){
        
      }
    },
    methods: {
      getDict,
      handleSelectClick(id){
        console.log(123)
        let index = this.selected.indexOf(id);
        if(index >= 0){
          this.selected.splice(index,1);
        }else{
          this.selected.push(id)
        }
      },
      submit(){
        if(this.selected.length == 0 && this.issue.trim().length == 0){
          this.$refs.alertBox.alert(this.getDict(24));
          return;
        }
        axios.post('/api/feedback', {
          "email":this.email,
          "issue":this.issue,
          "tags":this.selected,
          "videoId":this._feedbackObj.watchingVideoID||undefined,
        }).then((response)=>{
          if(this.isRouteOpen){
            this.$router.back();
          }else{
            this.$emit('submit');
          }
          
        }).catch((error)=>{
          // this.$router.back();
          switch(error.response.status){
            case 403:
            this.$refs.alertBox.alert(this.getDict(25));
            return;
            break;
          }
          console.log(error);
          this.$refs.alertBox.alert(this.getDict(26));
        });
      },
    },
    components: {
      alert,
    },
    mounted(){
      
    },
    created(){
      window.test = this
    }
  }
</script>

<style lang="scss" scoped>
  .container{
    margin: .3rem;
    display: flex;
    flex: 1;

    .background{
      $font-size:0.25rem;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: url(./imgs/bgimg.png) center no-repeat;
      background-size: auto 100%;
      font-size:$font-size;
      color: #fff;

      .block{
        $right-box-width:6rem;
        $title-width:1.7rem;
        $title-margin-right: 0.1rem;
        display: inline-block;
        &:not(:first-child){
          margin-top:0.45rem;
        }

        &.input{
          .input-box{
            background-color: #000;
            height: $font-size *1.5;
            input,textarea{
              width: 100%;
              height: 100%;
              // height: $font-size *1.5;
              font-size:$font-size;
              display: inline-block;
              border: none;
              color: #747474;
              background:none;
              padding-left: 0.1rem;
              
            }
          }
          
        }
        &.tips{
          width:$right-box-width + $title-width + $title-margin-right;
          font-size: 0.2rem;
          color: #f00;
        }

        &.button{
          button{
            font-size: 0.26rem;
            background: url(~@/assets/button.png) center no-repeat;
            background-size: 100% 100%;
            width: 2rem;
            height: 0.5rem;
          }
          
        }
        
        .title{
          float: left;
          width: $title-width;
          // background-color: rgba(100,0,0,0.2);
          display: flex;
          line-height: $font-size * 1.2;
          margin-right: $title-margin-right;
        }
        .right-box{
          float: left;
          width: $right-box-width;
          // background-color: rgba(0,0,0,0.2);


          .select-box{
            display: flex;
            justify-content: space-between;
            flex-wrap:wrap;

            .item{
              display: flex;
              // align-items: center;

              margin-top: 0.2rem;
              .icon{
                width: $font-size;
                height: $font-size;
                margin: #{$font-size * .1} 0 0;
                background-color: #000;
                flex-shrink: 0;
                // filter: brightness(0%);

                // &.active{
                //   filter: brightness(100%);
                // }
              }
              .desc{
                display: inline-block;
                margin-left: 0.07rem;
                line-height: $font-size * 1.2;
              }
            }
          }
          
        }
      }
    }
  }

  .select-box{
    width: 130%;
  }

  .lang-zht .select-box{
    width: 100%;
  }

</style>
